import React from 'react';
import { StatBox } from './StatBox';
import { Text, Icon, IconList, Link } from 'components/core';
import { tokenizeRoute, DUPLICATES_ROUTE } from 'query/routes';
import { getReviewId } from 'query/review';

type Props = {
  id: string;
  count: number;
};

const duplicatesRoute = (id: string) => {
  return tokenizeRoute(DUPLICATES_ROUTE, {
    review_id: getReviewId(),
    import_id: id,
  }).toString();
};

export const DuplicatesStatBox = ({ id, count }: Props) => {
  return (
    <StatBox
      header={
        <Link to={duplicatesRoute(id)}>
          Duplicates <Icon icon={IconList.light.faArrowUpRightFromSquare} />
        </Link>
      }
      value={<Text size="xxl">{count}</Text>}
    />
  );
};
